import React, { useEffect, useState } from "react";
import { NAV } from "@/constants/testIds";
import { SITE } from "@/lib/site";

const NavLink = ({ href, label, testId }) => (
  <a
    href={href}
    data-testid={testId}
    className="link-quiet text-[0.7rem] tracking-[0.22em] uppercase font-sans-mono"
  >
    {label}
  </a>
);

const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid={NAV.root}
      className={[
        "fixed top-0 left-0 right-0 z-40 transition-all duration-500",
        scrolled
          ? "bg-[#0B0C10]/85 backdrop-blur-md border-b border-[color:var(--soti-rule)]"
          : "bg-transparent",
      ].join(" ")}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14 py-5 flex items-center justify-between">
        <a
          href="#top"
          data-testid={NAV.brand}
          className="flex items-center gap-3 group"
        >
          <span
            className="inline-block w-[10px] h-[10px] rotate-45"
            style={{ background: "var(--soti-cinder)" }}
            aria-hidden="true"
          />
          <span className="overline text-[#F3EFEA] group-hover:text-[#D94833] transition-colors">
            {SITE.brand}
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          <NavLink href="#cinder-archive" label="Archive" testId={NAV.linkArchive} />
          <NavLink href="#book-premise" label="Premise" testId={NAV.linkPremise} />
          <NavLink href="#about-creator" label="Creator" testId={NAV.linkCreator} />
          <NavLink href="#professional-inquiries" label="Contact" testId={NAV.linkContact} />
        </nav>

        <a
          href={SITE.archiveUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={NAV.ctaArchive}
          className="btn-outline"
        >
          Enter the Archive
        </a>
      </div>
    </header>
  );
};

export default Nav;
